export default function FinalCTA() {
  return (
    <section
      className="text-center px-5 py-[72px] lg:py-24 lg:px-16"
      style={{ background: '#0E0E0C' }}
    >
      <div className="max-w-[680px] mx-auto">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/8 border border-white/10 rounded-full px-4 py-1.5 text-[12px] font-semibold text-white/50 mb-7">
          <span className="w-1.5 h-1.5 bg-green-500 rounded-full flex-shrink-0 pulse-dot" />
          Membro fundador · vagas limitadas
        </div>

        {/* Headline */}
        <h2 className="text-[34px] sm:text-[46px] lg:text-[60px] font-black tracking-[-1.5px] sm:tracking-[-2px] leading-[1.08] text-white mb-5">
          30 dias grátis.<br />Tudo liberado.
        </h2>

        {/* Sub */}
        <p className="text-[15px] lg:text-[16px] text-white/45 leading-[1.75] mb-9 max-w-[500px] mx-auto">
          Teste o WaitHere por 30 dias com acesso completo — sem cartão de crédito. Depois, Pro por R$149/mês com preço travado para quem entrar primeiro.
        </p>

        {/* CTA */}
        <a
          href="#testar-gratis"
          className="inline-flex items-center justify-center bg-white text-black no-underline px-9 py-[17px] rounded-full text-[16px] font-bold hover:bg-neutral-100 active:scale-[0.98] transition-all"
        >
          Começar 30 dias grátis →
        </a>

        {/* Trust */}
        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 mt-6">
          {['Sem cartão de crédito', 'Pronto em menos de 24 horas', 'Cancele quando quiser'].map((item) => (
            <div key={item} className="flex items-center gap-1.5 text-[12px] text-white/30">
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                <path d="M2 5.5l2 2L9 3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
